import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';

export const getLinkedEntityRoute = (
  assetId: string,
  entityType: LinkableEntityType,
  entityId: string,
  metadata?: Record<string, unknown>
): string => {
  switch (entityType) {
    case LinkableEntityType.Task:
      return `/asset/${assetId}/tasks/${entityId}`;
    case LinkableEntityType.Project:
      return `/asset/${assetId}/project-and-works/${entityId}`;
    case LinkableEntityType.Contact:
      return `/asset/${assetId}/contacts/${entityId}`;
    case LinkableEntityType.Expense:
      return `/asset/${assetId}/expenses/${entityId}`;
    case LinkableEntityType.VirtualFile:
      return `/asset/${assetId}/documents/${entityId}`;
    case LinkableEntityType.CommunityFeedItem:
      // A memory opens in Mémoire de la maison; an ordinary message stays on the wall.
      return metadata?.kind === 'memory'
        ? `/asset/${assetId}/memories/${entityId}`
        : `/asset/${assetId}/community/post/${entityId}`;
    case LinkableEntityType.Room:
      // Rooms have no page of their own: the Structure tab opens the room drawer from `room`
      return `/asset/${assetId}/admin?tab=structure&room=${entityId}`;
    case LinkableEntityType.Event:
      return `/asset/${assetId}/planning/event/${entityId}`;
    case LinkableEntityType.InventoryItem:
      return `/asset/${assetId}/inventories/${entityId}`;
  }
};
